<div class="grid" *ngIf="!isLoading">
    <div class="col-12 p-3 mt-3">
        <app-grid #grid
          [domLayout]="'autoHeight'"
          [columnDefs]="columnDefs"
          [style]="style"
          [rowHeight]="rowHeight"
          [rowData]="rowData"
          [useAddAction]="isProjectOwnershipValid"
          [isProjectOwnershipValid]="isProjectOwnershipValid"
          addLabel="Add Scheme"
          (deleteEvent)="deleteRow($event)"
          (dropDownSelectionChangeEvent)="onSelectionChanged($event)"
          (onFirstDataRenderedEvent)="onFirstDataRendered($event)"
          (saveEvent)="saveData($event)"
          (refreshEvent)="getData()"
          [isMasterDetail]="false"
          [useDetailAddButton]="false"
          [suppressRowClickSelection]="true"
          [rowSelection]="'multiple'"
          [rowMultiSelectWithClick]="true"
          [useDeleteAction]="isProjectOwnershipValid"
          (addEvent)="newRowAdded($event)"
          (onBlurInputText)="onBlurInputText($event)"
          (onSelectedRowEvent)="onSelectedRow($event)"
          (onRowSelectedEmit)="onSelectionChanged($event)"
          (enableControlsEmit)= "enableControls($event)" 
          ></app-grid>
    </div>
</div>
<app-loading class="mt-2 flex align-items-center justify-content-center" *ngIf="isLoading"></app-loading>
